import { useEffect } from 'react';

import { containsTarget } from '@/shared/ui/FloatingPanel';

/**
 * Закрывает dropdown/popup при клике снаружи указанных ref-элементов.
 */
export function useOutsideClick(params: {
  enabled: boolean;
  refs: React.RefObject<HTMLElement>[];
  onOutside: () => void;
}) {
  const { enabled, refs, onOutside } = params;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const onDown = (e: MouseEvent) => {
      const t = e.target as Node | null;
      if (!t) {
        return;
      }

      for (const r of refs) {
        if (containsTarget(r.current, t)) {
          return;
        }
      }
      onOutside();
    };

    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [enabled, refs, onOutside]);
}
